<p *ngIf="labelKey && !boxed" class="retrieval-mode-notice">
  <strong>{{ labelKey | translate }}</strong>
</p>

<div *ngIf="labelKey && boxed" class="retrieval-mode-notice retrieval-mode-notice--boxed">
  <img src="assets/icons/info.png" alt="" aria-hidden="true" class="retrieval-mode-notice-icon" />
  <p class="retrieval-mode-notice-text">
    {{ labelKey | translate }}
  </p>
</div>
